import styles from "./styles.module.scss";
interface IPDFComponentProps {
  fileUrl: string;
  fileName?: string;
  isHorizontalPDF?: boolean;
  isPreview?: boolean;
}

const PDFComponent = ({
  fileUrl,
  fileName,
  isHorizontalPDF,
  isPreview,
}: IPDFComponentProps) => {
  const name = fileName || fileUrl?.split("/")?.pop();
  const previewPDF = () => {
    window.open(fileUrl, "_blank", "rel=noopener noreferrer");
  };
  return (
    <div
      onClick={previewPDF}
      className={
        isHorizontalPDF
          ? styles["container"]
          : isPreview
          ? styles["preview_container"]
          : styles["normal_container"]
      }>
      <img alt="pdf" src={"/assets/images/svg/pdf.svg"} />
      {isHorizontalPDF ? (
        <>
          <p>{name}</p>
          <a
            target="_blank"
            download={name}
            href={fileUrl}
            onClick={(e) => e?.stopPropagation()}
            rel="noreferrer"
            className={styles["download"]}>
            <img alt="download" src={"/assets/images/svg/download.svg"} />
          </a>
        </>
      ) : (
        <div>
          <p>{name}</p>
          <a
            target="_blank"
            download={name}
            href={fileUrl}
            onClick={(e) => e?.stopPropagation()}
            rel="noreferrer">
            <img alt="download" src={"/assets/images/svg/download.svg"} />
          </a>
        </div>
      )}
    </div>
  );
};

export default PDFComponent;
